/**
 * Convert field position from canvas display pixels to SignWell API coordinates.
 * SignWell uses PDF points (72 DPI) as its coordinate system, which matches
 * the dimensions returned by pdf.js page.getViewport({ scale: 1 }).
 */
export function canvasToSignwell(field, canvasW, canvasH, pdfPageW, pdfPageH) {
  const scaleX = pdfPageW / canvasW;
  const scaleY = pdfPageH / canvasH;
  return {
    type: field.type,
    page: field.page,
    x: Math.round(field.x * scaleX),
    y: Math.round(field.y * scaleY),
    width: Math.round(field.width * scaleX),
    height: Math.round(field.height * scaleY),
    recipientIndex: field.recipientIndex,
    required: true,
  };
}

/**
 * Convert all placed fields to SignWell format.
 * pageDimensions is a Map of pageNum → { canvasW, canvasH, pdfW, pdfH }
 */
export function convertFieldsToSignwell(fields, pageDimensions) {
  return fields.map((field) => {
    const dims = pageDimensions.get(field.page);
    if (!dims) return null;
    return canvasToSignwell(field, dims.canvasW, dims.canvasH, dims.pdfW, dims.pdfH);
  }).filter(Boolean);
}
